import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import smoothscroll from 'smoothscroll-polyfill';
import 'react-hot-loader';
import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { StylesProvider } from '@material-ui/core/styles';
import 'i18n';
import ReduxObserver from 'components/ReduxObserver';
import { Provider as ReduxProvider } from 'react-redux';
import { ApolloProvider } from '@apollo/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import { ENV, SENTRY_RELEASE_VERSION_NUMBER } from 'appenv';
import AppRouter from 'routes/AppRouter';
import { UserSessionContextStateProvider } from 'components/UserSession';
import { EventDatetimeContextStateProvider } from 'components/EventDatetime';
import ExhibitorPanel from 'components/exhibitorPanel';
import { SplitioContextProvider } from 'components/SplitioContext';
import ChatSwitch from 'components/ChatSwitch';
import EnvIndicator from 'components/EnvIndicator';
import store from './store';
import apolloClient from './apolloClient';
import FaviconWrapper from './FaviconWrapper';
import PictureInPicture from './components/pictureInPicture/PictureInPicture';
import AttendeeEnrichmentData from './components/AttendeeEnrichmentData';

smoothscroll.polyfill();

Sentry.init({
  dsn: 'https://102260f2878947fe97af05b72446502d@o137190.ingest.sentry.io/5280956',
  ignoreErrors: ['ChunkLoadError', "Cannot read property 'append' of null"],
  environment: ENV,
  release: SENTRY_RELEASE_VERSION_NUMBER,
  integrations: [new Integrations.BrowserTracing()],
  beforeSend(event, hint) {
    if (typeof hint.originalException === 'string') {
      if (hint.originalException.startsWith('Object Not Found Matching Id')) {
        return null;
      }

      if (hint.originalException === '') {
        return null;
      }
    }

    return event;
  },
});

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(
    <>
      <ReduxProvider store={store}>
        <ApolloProvider client={apolloClient}>
          <FaviconWrapper />
          <ReduxObserver />
          <StylesProvider injectFirst>
            <EventDatetimeContextStateProvider>
              <UserSessionContextStateProvider>
                <SplitioContextProvider>
                  <BrowserRouter>
                    <ChatSwitch>
                      <PictureInPicture />
                      <ExhibitorPanel />
                      <AttendeeEnrichmentData />
                      <AppRouter />
                    </ChatSwitch>
                  </BrowserRouter>
                </SplitioContextProvider>
              </UserSessionContextStateProvider>
            </EventDatetimeContextStateProvider>
          </StylesProvider>
          <EnvIndicator />
        </ApolloProvider>
      </ReduxProvider>
    </>,
    document.getElementById('root'),
  );
});
